import styled from "styled-components";

export const ConditionalDisplayWrapper = styled.div<{
  displayOnScreen?: boolean;
}>`
  display: ${({ displayOnScreen }): string =>
    displayOnScreen ? "block" : "none"};
`;
